import React, { useRef, useState,useEffect } from 'react';


const AudioPlayer = ({
  src,
  image,
  title = 'Título de la pista',
  description = 'Descripción de la pista',
  totalTime = '03:45',
}) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isLoop, setIsLoop] = useState(false);

  useEffect(() => {
    setIsPlaying(true);
  },[src]);
  const handlePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(audioRef.current.duration);
  };

  const handleToggleLoop = () => {
    setIsLoop((prev) => !prev);
    if (audioRef.current) {
      audioRef.current.loop = !isLoop;
    }
  };

  const formatTime = (time) => {
    const min = Math.floor(time / 60);
    const sec = Math.floor(time % 60);
    return `${min}:${sec < 10 ? '0' : ''}${sec}`;
  };

  return (
    <div className="audio-player">
      <div className="audio-player__header">Reproduciendo</div>
      <div className="audio-player__main">
        <img src={image} alt="cover" className="audio-player__image" />
        <div className="audio-player__info">
          <h3 className="audio-player__title">{title}</h3>
          {/* <p className="audio-player__desc">{description}</p> */}
        </div>
      </div>
      <audio
        ref={audioRef}
        src={src}
        autoPlay
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        loop={isLoop}
      />
      <div className="audio-player__progress">
        <span>{formatTime(currentTime)}</span>
        <input
          type="range"
          min="0"
          max={duration}
          value={currentTime}
          onChange={e => {
            const val = Number(e.target.value);
            audioRef.current.currentTime = val;
            setCurrentTime(val);
          }}
        />
        <span>{formatTime(duration) || totalTime}</span>
      </div>
      <div className="audio-player__controls">
        <button className="audio-player__btn audio-player__btn--counters audio-player__btn--disabled" title="Random" disabled>
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-shuffle-icon lucide-shuffle"><path d="m18 14 4 4-4 4"/><path d="m18 2 4 4-4 4"/><path d="M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22"/><path d="M2 6h1.972a4 4 0 0 1 3.6 2.2"/><path d="M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45"/></svg>
        </button>
        <button className="audio-player__btn audio-player__btn--disabled" title="Anterior" disabled>
       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-skip-back-icon lucide-skip-back"><polygon points="19 20 9 12 19 4 19 20"/><line x1="5" x2="5" y1="19" y2="5"/></svg>
        </button>
        <button
          className="audio-player__btn audio-player__btn--main"
          onClick={handlePlayPause}
        >
          {isPlaying ? (
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-pause-icon lucide-pause"><rect x="14" y="4" width="4" height="16" rx="1"/><rect x="6" y="4" width="4" height="16" rx="1"/></svg>
          ) : (
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-play-icon lucide-play"><polygon points="6 3 20 12 6 21 6 3"/></svg>
          )}
        </button>
        <button className="audio-player__btn audio-player__btn--disabled" title="Siguiente" disabled>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-skip-forward-icon lucide-skip-forward"><polygon points="5 4 15 12 5 20 5 4"/><line x1="19" x2="19" y1="5" y2="19"/></svg>
        </button>
        <button
          className={`audio-player__btn audio-player__btn--counters audio-player__btn--repeat${isLoop ? ' audio-player__btn--active' : ''}`}
          title="Repetir"
          onClick={handleToggleLoop}
          type="button"
        >
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-repeat-icon lucide-repeat"><path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/></svg>
        </button>
      </div>
    </div>
  );
};

export default AudioPlayer;
